// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'ec606ae8-8769-43b7-8b4e-002caf4d0205',
      type: 'Container',
      runtimeType: null,
      name: 'impactContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '0cbf866f-5d0a-4602-90e3-9fe2672ab487',
      type: 'Sprite',
      runtimeType: null,
      name: 'hammerSprite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.14,
        y: 0.33
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Animation_Frame_14',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class HammerAnimationLayout {
  static raw = raw;
  root: Container;
  impactContainer: Container;
  hammerSprite: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      impactContainer: typeof raw['list'][1];
      hammerSprite: typeof raw['list'][2];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
